import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'

import { Information } from '@components/UI/Information'
import InformationContent from '@components/UI/Information/Content/Content'
import ConnectedTrackedRoute from '@components/UI/TrackedRoute/ConnectedTrackedRoute'
import { EventTrackingNames } from '@enums'
import hooks from '@hooks'
import { IApplicationState } from '@store'
import {
  downloadPostCampaignReportRequest,
  selectIsReadyForDownload,
} from '@store/postCampaignReport'
import { selectCampaignId } from '@store/router'
import Theme from '@theme'
import { Button, Container } from '@tribegroup'
import { getCampaignMetricsTab } from '@utils'

const PostCampaignReportTitleButton: React.FC = () => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match)!
  const enableDownloadButton = useSelector((state: IApplicationState) =>
    selectIsReadyForDownload(state, campaignId),
  )
  const dispatch = useDispatch()
  const { channel } = hooks.useLocationSearch()

  const onClick = () => {
    const timezoneInfo = Intl.DateTimeFormat().resolvedOptions().timeZone
    dispatch(downloadPostCampaignReportRequest(campaignId, timezoneInfo))
  }

  if (enableDownloadButton) {
    return (
      <ConnectedTrackedRoute
        campaignId={campaignId}
        eventName={EventTrackingNames.CampaignMetricsDownloadCSV}
        additionalProperties={{ metrics_tab: getCampaignMetricsTab(channel) }}
      >
        <Button onClick={onClick} small height={2} outlined data-testid="pcr-enabled-button">
          <FormattedMessage id="postCampaignReport.header.button.downloadCSV" />
        </Button>
      </ConnectedTrackedRoute>
    )
  }

  return (
    <Information
      target={
        <Button
          onClick={onClick}
          small
          height={2}
          hasIcon
          disabled
          data-testid="pcr-disabled-button"
        >
          <Container>
            <FormattedMessage id="postCampaignReport.header.button.downloadCSV" />
          </Container>
        </Button>
      }
      width={18.125}
      panelTopOffset={1.25}
      panelRightOffset={1.25}
    >
      <InformationContent
        titleColor={Theme.primaryColor}
        title={<FormattedMessage id="postCampaignReport.header.button.downloadCSV" />}
        content={<FormattedMessage id="postCampaignReport.header.button.downloadCSV.tooltip" />}
      />
    </Information>
  )
}

export default PostCampaignReportTitleButton
